/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { generalPartition } from "../../funcs/generalPartition.js";
import * as operations from "../../sdk/models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.PartitionRequest$inboundSchema,
};

export const tool$generalPartition: ToolDefinition<typeof args> = {
  name: "general-partition",
  description: `Summary

Description`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await generalPartition(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
